module.exports = __webpack_public_path__ + "static/media/Sesamo.4da91dda.png";